import { useQuery } from "@tanstack/react-query";
import { ApiGetWithdrawAndRechargeRecord } from "@/api";
import type { WithdrawAndRechargeRecordItem } from "@/api/types";

export const useWithdrawAndRechargeRecord = (
  type: number,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["withdrawAndRechargeRecord", type],
    queryFn: async () => {
      const res = await ApiGetWithdrawAndRechargeRecord({
        includeStartTime: 0,
        excludeEndTime: Date.now(),
        limit: 500,
        type,
      });
      const wait = res.data.waitCheckItems ?? [];
      const items = res.data.items ?? [];
      const merged: WithdrawAndRechargeRecordItem[] = [...wait, ...items];
      console.log("merged", merged);
      return merged;
    },
    enabled: options?.enabled ?? true,
  });
};
